import styled from 'styled-components';
import { getHandleActionKeyDown } from '@elfsight/widget-utils';
import type { Language } from '../../../types';
import type { FlagProps } from '../flag';
import { Flag } from '../flag';
import { Name } from '../name';

type DropdownItemProps = {
  name: Language['originalName'];
  ariaLabel?: string;
  selected?: boolean;
  icon?: FlagProps['icon'];
  iconStyle?: FlagProps['style'];
  onClick: () => void;
};

export function DropdownItem({
  name,
  ariaLabel,
  selected = false,
  icon,
  iconStyle,
  onClick
}: DropdownItemProps) {
  const finalAriaLabel = ariaLabel || name;

  return (
    <Wrapper
      role="option"
      aria-selected={selected}
      tabIndex={0}
      aria-label={finalAriaLabel}
      onKeyDown={getHandleActionKeyDown(onClick)}
      onClick={onClick}
    >
      {!!icon && <Flag icon={icon} style={iconStyle} isDecorative />}
      <Name name={name} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 16px;
  gap: 12px;
  cursor: pointer;
  color: black;

  &:hover,
  &:focus-visible {
    background-color: rgba(17, 17, 17, 0.05);
  }

  &:focus-visible {
    outline: 2px solid rgb(0, 95, 204) !important;
    outline-offset: -2px;
    box-shadow: inset 0 0 0 4px white;
    border-radius: 8px;
  }
`;
